import { render, staticRenderFns } from "./MyStats.vue?vue&type=template&id=52899f91&scoped=true"
import script from "./MyStats.vue?vue&type=script&lang=js"
export * from "./MyStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52899f91",
  null
  
)

export default component.exports